"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartiuRole = void 0;
var PartiuRole;
(function (PartiuRole) {
    PartiuRole["user"] = "user";
    PartiuRole["admin"] = "administrator";
    PartiuRole["staff"] = "agreement-staff";
    PartiuRole["pdv"] = "pdv";
})(PartiuRole = exports.PartiuRole || (exports.PartiuRole = {}));
//# sourceMappingURL=core.js.map